(function ($) {
  'use strict';

  const SLIDER_SELECTOR = '.js-card-slider';

  function initSlider($slider) {
    const slidesToShow = parseInt($slider.data('slides'), 10) || 3;
    const hasMultiple = $slider.children().length > slidesToShow;

    $slider.slick({
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: hasMultiple,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: Math.min(slidesToShow, 2),
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '40px',
          },
        },
      ],
    });
  }

  $(function () {
    if (typeof $.fn.slick !== 'function') {
      return;
    }

    $(SLIDER_SELECTOR).each(function () {
      initSlider($(this));
    });
  });
})(jQuery);
